import { render, staticRenderFns } from "./MallSelectionModal.vue?vue&type=template&id=8b3f0522&scoped=true&"
import script from "./MallSelectionModal.vue?vue&type=script&lang=ts&"
export * from "./MallSelectionModal.vue?vue&type=script&lang=ts&"
import style0 from "./MallSelectionModal.vue?vue&type=style&index=0&id=8b3f0522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3f0522",
  null
  
)

export default component.exports